import hasNewCasino from "@/util/hasNewCasino";
import hasExemptPlayer from "@/util/hasExemptPlayer";

export default {
  install(Vue) {
    Vue.prototype.$permission = function(id) {
      const user_data = JSON.parse(localStorage.getItem("user_data"));

      if (!user_data) {
        return false;
      }

      if (user_data.isCollaborator) {
        const permissions = user_data.permissions;
        return permissions.find((permission) => permission.permissions == id);
      }

      return true;
    };

    Vue.prototype.$prefix = function() {
      const mapLevelToEndpointPrefix = {
        collaborator: "colab",
        administrator: "administrator",
        regionalManager: "regionalManager",
        localManager: "localManager",
      };

      return mapLevelToEndpointPrefix[localStorage.getItem("level")];
    };

    Vue.prototype.$hasNewCasino = function() {
      const domain = localStorage.getItem("operator");
      return hasNewCasino.includes(domain);
    };

    Vue.prototype.$hasExemptPlayer = function() {
      const domain = localStorage.getItem("operator");
      return hasExemptPlayer.includes(domain);
    };
  },
};
